import { hbs } from 'ember-cli-htmlbars';
export default hbs("<h3 class=\"bv-subheading\" aria-label={{@title}} ...attributes>\n  {{#if (has-block)}}\n    {{yield}}\n  {{else}}\n    {{@title}}\n  {{/if}}\n</h3>")